import { Component, OnInit } from '@angular/core';
import { LayoutService } from '@common/services/layout.service';
import { ModalService } from '@common/services/modal.service';
import { Filterable } from '@common/utilities/Filterable';
import { ConfigsService } from '@core/services/configs.service';
import { DataService, PaymentRecord, PaymentState, PaymentType } from '@core/services/data.service';
import { GroupsService } from '@core/services/groups.service';
import { ServicesService } from '@core/services/services.service';
import { SynchronizationService } from '@core/services/synchronization.service';
import { Multilingual } from '@core/utilities/multilingual';
import { ServicePaymentEditorComponent } from '@routes/editors/service-payment-editor/service-payment-editor.component';
import { map } from 'rxjs/operators';

@Component({
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss']
})
export class ServicesComponent implements OnInit {

  public payments = new Filterable<PaymentRecord>({ extractor: i => [i.Notes] });

  constructor(public configs: ConfigsService, private layout: LayoutService, private sync: SynchronizationService, private ds: DataService, private modal: ModalService, private services: ServicesService, private groups: GroupsService) { }

  public get loading(): boolean {
    return !this.sync.ready(ServicesComponent);
  }

  ngOnInit(): void {
    this.layout.title = Multilingual.getText('Thu chi dịch vụ');
    this.layout.media('footer', 'none');
    this.synchronize();    
  }

  public add(type: 'income' | 'expense') {

    let stamp = new Date().getTime();

    this.modal.show(ServicePaymentEditorComponent, {
      state: {
        payment: {
          ID: 0,
          Type: PaymentType.Service + (type == 'income' ? PaymentType.Income : PaymentType.Expense),

          PartnerID: 0,

          SendAmount: 0,
          SendSymbol: 'VND',

          ReceiveAmount: 0,
          ReceiveSymbol: 'VND',

          Notes: '',

          State: PaymentState.Editable,

          Stamp: stamp,
          FirstStamp: stamp,
          LastStamp: stamp,
          CreatorID: 0,
          UpdatorID: 0
        }
      }, ignoreBackdropClick: true
    })
      .content.update.subscribe(payment => {
        this.payments.source = this.payments.source.filter(i => i.ID != payment.ID).union([payment]);
      });
  }

  public type(payment: PaymentRecord): 'income' | 'expense' {
    return payment.Type == PaymentType.Income + PaymentType.Service ? 'income' : 'expense';
  }

  public editable(payment: PaymentRecord): boolean {
    return payment.State == PaymentState.Editable;
  }

  public open(payment: PaymentRecord) {
    this.modal.show(ServicePaymentEditorComponent, { state: { payment: payment }, ignoreBackdropClick: true }).content.update.subscribe(payment => {
      this.payments.source = this.payments.source.filter(i => i.ID != payment.ID).union(payment.State != PaymentState.Canceled ?[payment] : []);
    });
  }

  public partner(payment: PaymentRecord): string {
    return this.services.get(payment.PartnerID).Name;
  }

  public group(payment: PaymentRecord): string {
    let partner = this.services.get(payment.PartnerID);
    if (!partner) return '';

    let group = this.groups.get(partner.GroupID);
    return group ? group.Name : '';
  }

  public synchronize() {

    this.sync.with(ServicesComponent).repeat(() => this.ds.payments('services').pipe(map(payments => {
      if (payments) {
        this.payments.source = payments;
        return true;
      }

      return false;
    })));
  }
}
